<template lang='pug' src='./treatment.pug'></template>

<script>
import Loader from 'components/loader/loader'
import ModalContact from 'components/modal/modal-contact/modal-contact'
import BlockTitle from 'components/block/block-title/block-title'
import CustomTreatmentInvisalign from 'components/custom/custom-treatment-invisalign/custom-treatment-invisalign'
import CustomTreatmentTabs from 'components/custom/custom-treatment-tabs/custom-treatment-tabs'
import DividerText from 'components/divider/divider-text/divider-text'
import CustomTreatmentAcceleratedTreatments from 'components/custom/custom-treatment-accelerated-treatments/custom-treatment-accelerated-treatments'
import CustomTreatmentItero from 'components/custom/custom-treatment-itero/custom-treatment-itero'

export default {
  name: 'treatment',
  computed: {
    props () {
      return this.$store.state.pages.treatment
    },
    loading () {
      return this.$store.state.loading
    }
  },
  created () {
    this.$store.dispatch('VIEW_NAV', true)
  },
  components: {
    Loader,
    ModalContact,
    BlockTitle,
    CustomTreatmentInvisalign,
    CustomTreatmentTabs,
    DividerText,
    CustomTreatmentAcceleratedTreatments,
    CustomTreatmentItero
  }
}
</script>



// WEBPACK FOOTER //
// treatment.vue?4613b5da